import { render, staticRenderFns } from "./SettingsContentTracking.vue?vue&type=template&id=2c6c9994&lang=pug&"
import script from "./SettingsContentTracking.vue?vue&type=script&lang=js&"
export * from "./SettingsContentTracking.vue?vue&type=script&lang=js&"
import style0 from "./SettingsContentTracking.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports